module.exports = {"id":"199451","name":"Wissam Ben Yedder","rating":"81","photo":"./data/images/photos/3/199451.png","club":{"name":"Séville FC","logo":"./data/images/clubs/SevilleFC.png"},"positions":["BU","MOC","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WissamBenYedder0.json
// module id = 4360
// module chunks = 0